<template>
  <a-modal title="续期" :width="600" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <a-alert message="续费成功后，请重启机器人生效" type="info" :style="{ marginBottom: '20px' }" />
      <a-form :form="form">
        <a-form-item label="机器人子账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['id', { initialValue: currentRobotId }]" read-only />
        </a-form-item>
        <a-form-item label="卡密" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['recharge_card', { rules: [{ required: true, message: '必填项' }] }]"
            placeholder="请填写卡密"
          />

          <!-- <span slot="help">
            <a @click="goWph" class="goWph">戳我！冲刺唯品会，免费领卡密</a>
          </span> -->
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          DeviceApi.renewal({ id: values.id, recharge_card: values.recharge_card })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('续期成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },

    // 冲刺唯品会
    goWph() {
      window.open('http://zjzd.nianchu.net/thread/600')
    },
  },
}
</script>

<style scoped>
.goWph {
  color: red;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
